<div class="saved-professions">
  <div class="saved-professions__hero">
    <div class="vacancy-hero">
      <h1 class="vacancy-hero__title">{{ 'professions.saved.hero_title' | translate }}</h1>
    </div>
  </div>

  <div class="vacancy-container saved-professions__content">
    <div class="vacancy-empty-state" *ngIf="savedProfessions.length === 0">
      <div class="saved-professions__empty-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/>
        </svg>
      </div>
      <h2 class="vacancy-empty-state__title">{{ 'professions.saved.empty_title' | translate }}</h2>
      <p class="vacancy-empty-state__text">{{ 'professions.saved.empty_text' | translate }}</p>
      <a routerLink="/profile-check/professions" class="saved-professions__back-link">{{ 'professions.saved.back_link' | translate }}</a>
    </div>

    <div class="vacancy-grid" *ngIf="savedProfessions.length > 0">
      <bwc-profession-card
        *ngFor="let profession of savedProfessions"
        [profession]="profession"
        [isLiked]="true"
        (liked)="unlike($event)"
      ></bwc-profession-card>
    </div>
  </div>
</div>
